export const futuresCode = [
  {label: '白糖', value: 'SR'}, 
  {label: '棉花', value: 'CF'}, 
  {label: '普麦', value: 'PM'}, 
  {label: '强麦', value: 'WH'}, 
  {label: '早籼稻', value: 'RI'}, 
  {label: '晚籼稻', value: 'LR'}, 
  {label: '粳稻', value: 'JR'}, 
  {label: '菜籽粕', value: 'RM'}, 
  {label: '油菜籽', value: 'RS'}, 
  {label: '菜籽油', value: 'OI'}, 
  {label: '棉纱', value: 'CY'}, 
  {label: '苹果', value: 'AP'}, 
  {label: '红枣', value: 'CJ'}, 
  {label: '花生', value: 'PK'},
  {label: '动力煤', value: 'ZC'},
  {label: '精对苯二甲酸', value: 'PTA'},
  {label: '甲醇', value: 'MA'},
  {label: '玻璃', value: 'FG'},
  {label: '硅铁', value: 'SF'},
  {label: '锰硅', value: 'SM'},
  {label: '尿素', value: 'UR'},
  {label: '纯碱', value: 'SA'},
  {label: '短纤', value: 'PF'},
  {label: '对二甲苯', value: 'PX'},
  {label: '烧碱', value: 'SH'},
  {label: '玉米', value: 'C'},
  {label: '玉米淀粉', value: 'CS'},
  {label: '豆一', value: 'A'},
  {label: '豆二', value: 'B'},
  {label: '豆粕', value: 'M'},
  {label: '豆油', value: 'Y'},
  {label: '棕榈油', value: 'P'},
  {label: '纤维板', value: 'FB'},
  {label: '胶合板', value: 'BB'},
  {label: '鸡蛋', value: 'JD'},
  {label: '粳米', value: 'RR'},
  {label: '生猪', value: 'LH'},
  {label: '原木', value: 'LG'},
  {label: '聚乙烯', value: 'L'},
  {label: '聚氯乙烯', value: 'V'},
  {label: '聚丙烯', value: 'pp'},
  {label: '焦煤', value: 'JM'},
  {label: '焦炭', value: 'J'},
  {label: '铁矿石', value: 'I'},
  {label: '乙二醇', value: 'EG'},
  {label: '苯乙烯', value: 'EB'},
  {label: '液化石油气', value: 'PG'},
  {label: '铜', value: 'CU'},
  {label: '铝', value: 'AL'},
  {label: '锌', value: 'ZN'},
  {label: '铅', value: 'PB'},
  {label: '镍', value: 'NI'},
  {label: '锡', value: 'SN'},
  {label: '氧化铝', value: 'AO'},
  {label: '黄金', value: 'AU'},
  {label: '白银', value: 'AG'},
  {label: '螺纹钢', value: 'RB'},
  {label: '线材', value: 'WR'},
  {label: '热卷', value: 'HC'},
  {label: '不锈钢', value: 'SS'},
  {label: '燃料油', value: 'FU'},
  {label: '石油沥青', value: 'BU'},
  {label: '丁二烯橡胶', value: 'BR'},
  {label: '天然橡胶', value: 'RU'},
  {label: '纸浆', value: 'SP'},
  {label: '国际铜', value: 'BC'},
  {label: '原油', value: 'SC'},
  {label: '低硫燃料油', value: 'LU'},
  {label: '20号胶', value: 'NR'},
  {label: 'SCFIS欧线', value: 'EC'}
] 


// WEBPACK FOOTER //
// ./src/views/components/futures-code.js